'use client';

import dynamic from 'next/dynamic';
import { FormServer } from './form-server';
import { ContactProps } from './type';

const FormClient = dynamic(() => import('./form-client'), {
  ssr: false,
  loading: () => <FormServer consent="" fieldsPrefix="form" />,
});

export default function FormWrapper({
  consent,
  variant,
  submitVariation,
  preppendForm,
  appendForm,
  className,
  appendMessage,
  sticky,
  fieldsPrefix = 'form',
  hideInjuryQuestions,
}: ContactProps) {
  return (
    <FormClient
      consent={consent}
      variant={variant}
      submitVariation={submitVariation}
      preppendForm={preppendForm}
      appendForm={appendForm}
      appendMessage={appendMessage}
      className={className}
      sticky={sticky}
      fieldsPrefix={fieldsPrefix}
      hideInjuryQuestions={hideInjuryQuestions}
    />
  );
}
